"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceUrl = void 0;
const logs_1 = require("./logs");
const query_1 = require("./query");
class ResourceUrl {
    constructor(protocol, value) {
        this.protocol = protocol;
        this.value = value;
    }
    protocol;
    value;
    params;
    static getResource(protocol, value) {
        if (!protocol || !value) {
            logs_1.logs.error(`请输入合法的resourceUrl protocol: ${protocol} value: ${value}`);
        }
        return new ResourceUrl(protocol, value);
    }
    static getResourceByUrl(resourceUrl) {
        const [protocol] = resourceUrl.split('://');
        const value = resourceUrl.replace(`${protocol}://`, '');
        if (!protocol || !value) {
            logs_1.logs.error(`请输入合法的resourceUrl: ${resourceUrl}`);
        }
        const _resourceUrl = new ResourceUrl(protocol, value || '');
        if (value?.includes('?')) {
            const str = value.split('?');
            let _value = str[0];
            _resourceUrl.value = _value;
            _resourceUrl.params = (0, query_1.parseQuery)(str[1]);
        }
        return _resourceUrl;
    }
    getValueAsNumber() {
        return Number(this.value);
    }
    getValue() {
        return String(this.value || '');
    }
    getParams() {
        return this.params;
    }
    getProtocol() {
        return this.protocol;
    }
    getUrl() {
        let url = [this.protocol, this.value].join('://');
        if (null != this.params) {
            url += '?' + (0, query_1.stringifyQuery)(this.params);
        }
        return url;
    }
}
exports.ResourceUrl = ResourceUrl;
//# sourceMappingURL=resourceUrl.js.map